module.exports = __webpack_public_path__ + "img/card-tick-1.26cc7f90.svg";